import React, { Fragment } from 'react';
import SalesBotChatLauncher from './components/SalesBotChatLauncher';
import PearsonHome from './pearsonHome/PearsonHome';

const SalesBotContainer = () => (
  <>
    <PearsonHome />
    <SalesBotChatLauncher />
  </>
);

export default SalesBotContainer;
